import { createContext } from 'react';

import {
  AppShellProps,
  ArticleMetadata,
  PublishStatus,
  FavoritesProps,
  Present,
  BlockMetadata,
} from '/types';

export const AppShellContext = createContext({} as AppShellProps);

export const PublishStatusContext = createContext('live' as PublishStatus);

export const FavoritesContext = createContext({} as FavoritesProps);

export const PresentModeContext = createContext(Present.Off);

export const BlockBackgroundContext = createContext({ darkBg: false });

export const MetadataContext = createContext({} as ArticleMetadata);

export const BlockMetadataContext = createContext({} as BlockMetadata);
